import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import AppBar from "../components/AppBar";
import Toolbar from "../components/Toolbar";
import { SocialLinks } from "../components/SocialLinks";

const rightLink = {
  fontSize: 16,
  color: "common.white",
  ml: 3,
};

function AppAppBar() {
  return (
    <div>
      <AppBar position="fixed" component="nav" aria-label="Main navigation">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: { xs: 1, sm: 2 } }}>
            <Link color="inherit" variant="h6" underline="none" href="#about" sx={rightLink}>About</Link>
            <Link color="inherit" variant="h6" underline="none" href="#books" sx={rightLink}>Books</Link>
            <Box sx={{ ml: { xs: 1, sm: 2 }, display: "flex", alignItems: "center" }}>
              <SocialLinks location="header" />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;
